import Vue from 'vue'
import Router from 'vue-router'
import { constantRouterMap,dynamicRouter,devOpsRouter } from "@/config/router.config";

import layou from '@/views/layou/layouHome'//公共样式
import layou_bw from '@/views/layou_bw/layouHome'//公共样式白色背景
import login from '@/views/login';//登录界面
import guidance from '@/views/guidance';//引导页
import devOps from '../views/devOps/inedx.vue'//运维界面
import warehouse from '@/views/warehouse';//库房管理
import maintenance from '@/views/maintenance';//使用管理
import equipmentbind from '@/views/warehouse/equipmentbind';//仪器柜绑定
import companymanage from '@/views/sysmanage/Companymanage';//公司管理
import usermanage from '@/views/usermanage';//用户管理
import checkingUser from '@/views/usermanage/checkingUser';//待审核用户
import Datamanagement from '@/views/Datamanagement'//项目管理
import Applicationmana from '@/views/Datamanagement/Applicationmana'//申请管理
import VertifyOrder from '@/views/VertifyOrder';//送检单
import StandardMana from '@/views/StandardMana';//规范库
import MechanismMana from '@/views/MechanismMana';//检测机构
import fetchView from '@/views/fetch';//检测机构
import approvalManagement from '@/views/approvalManagement/index.vue';//审批管理

//仪器管理菜单模块
import InstaruEquipment from "@/views/Instrumentmanagemen/index.vue";//仪器管理模块下仪器列表

//路由懒加载
Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/login',
      hidden: true,
      meta: { title: "登录", icon: '' },
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      hidden: true,//在菜单显示还是隐藏
      meta: { title: "登录", icon: '' },
    },
    {
      path: '/guidance',
      name: 'guidance',
      component: guidance,
      meta: { title: "首页", icon: '' },
    },
    {
      path: '/devOps',
      name: 'devOps',
      component: devOps,
      hidden: true,
      meta: {
        title: "运维",
        icon: '',
        hidden: true
      },
    },
    {
      path: '/employ',
      name: 'employ',
      component: layou,
      meta: { title: "使用管理", icon: '' },
      hidden: false,
      redirect: '/employ/maintenance',
      children: [
        {
          path: '/employ/maintenance',
          name: 'maintenance',
          component: maintenance,
          meta: { title: '使用管理', icon: '' },
          hidden: false
        }
      ]
    },
    {
      path: '/instaru',
      name: 'instaru',
      component: layou,
      meta: { title: '仪器管理', icon: '' },
      hidden: false,
      redirect: '/instaru/equipment',
      children: [
        {
          path: '/instaru/equipment',
          name: 'equipment',
          component: InstaruEquipment,
          meta: { title: '仪器列表', icon: '' },
          hidden: false
        }
      ]
    },
    {
      path: '/warehouse',
      name: 'warehouse',
      component: layou,
      meta: { title: '库房管理', icon: '' },
      hidden: false,
      redirect: '/warehouse/warehousemana',
      children: [
        {
          path: '/warehouse/warehousemana',
          name: 'warehousemana',
          component: warehouse,
          meta: { title: '库房管理', icon: '' },
          hidden: false
        },
        {
          path: '/warehouse/equipmentbind',
          name: 'equipmentbind',
          component: equipmentbind,
          meta: { title: '设备仪器柜绑定', icon: '' },
          hidden: true
        },
      ]
    },
    {
      path: '/approval',
      name: 'approval',
      component: layou,
      meta: { title: '审批管理', icon: '' },
      hidden: false,
      redirect: '/approval/index',
      children: [
        {
          path: '/approval/index',
          name: 'approvalIndex',
          component: approvalManagement,
          meta: { title: '审批管理', icon: '' },
          hidden: false
        },
    
      ]
    },
    {
      path: '/sys',
      name: 'sys',
      component: layou_bw,
      meta: { title: '系统管理', icon: '' },
      hidden: false,
      redirect: '/sys/companymanage',
      children: [
        {
          path: '/sys/companymanage',
          name: 'companymanage',
          component: companymanage,
          meta: { title: '公司管理', icon: '' }
        },
      ]
    },
    {
      path: '/user',
      name: 'user',
      component: layou_bw,
      meta: { title: '用户管理', icon: '' },
      hidden: false,
      redirect: '/user/usermanage',
      children: [
        {
          path: '/user/usermanage',
          name: 'usermanage',
          component: usermanage,
          meta: { title: '用户列表', icon: '' },
          hidden: false
        },
        {
          path: '/user/checkingUser',
          name: 'checkingUser',
          component: checkingUser,
          meta: { title: '待审核用户', icon: '' }
        }
      ]
    },
    {
      path: '/data',
      name: 'data',
      component: layou_bw,
      meta: { title: '资料管理', icon: '' },
      hidden: false,
      redirect: '/data/datamanagement',
      children: [
        {
          path: '/data/datamanagement',
          name: 'datamanagement',
          component: Datamanagement,
          meta: { title: '项目管理', icon: '' },
          hidden: false
        },
        {
          path: '/data/applicationmana',
          name: 'applicationmana',
          component: Applicationmana,
          meta: { title: '申请管理', icon: '' }
        },
        {
          path: '/instaru/fetch',
          name: 'fetch',
          component: fetchView,
          meta: { title: '批量取出', icon: '' },
          hidden: false
        }
      ]
    },
    {
      path: '/vertify',
      name: 'vertify',
      component: layou_bw,
      meta: { title: '送检管理', icon: '' },
      hidden: true,
      redirect: '/vertify/vertifyorder',
      children: [
        {
          path: '/vertify/vertifyorder',
          name: 'vertifyorder',
          component: VertifyOrder,
          meta: { title: '送检单', icon: '' },
          hidden: false
        },
      ]
    },
    {
      path: '/standard',
      name: 'standard',
      component: layou_bw,
      meta: { title: '规范库管理', icon: '' },
      hidden: true,
      redirect: '/standard/standardmana',
      children: [
        {
          path: '/standard/standardmana',
          name: 'standardmana',
          component: StandardMana,
          meta: { title: '规范库', icon: '' },
          hidden: false
        },
      ]
    },
    {
      path: '/mechanism',
      name: 'mechanism',
      component: layou_bw,
      meta: { title: '检测机构管理', icon: '' },
      hidden: true,
      redirect: '/mechanism/mechanismmana',
      children: [
        {
          path: '/mechanism/mechanismmana',
          name: 'mechanismmana',
          component: MechanismMana,
          meta: { title: '检测机构', icon: '' },
          hidden: false
        },
      ]
    }
  ]
});

// let router  = new Router({
//   mode: 'history',
//   routes: constantRouterMap
// });

// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    next();
  } else {
    let token = sessionStorage.getItem('Authorization');
    if (token === null || token == undefined || token == '') {
      next('/login');
    } else {
      const rt = JSON.parse(sessionStorage.getItem('store'));
      // 判断用户属于那种角色，就添加那种路由
      // console.log("--------------->", rt);
      if (rt) {
        router.options.routes = rt.user.router;
      }
      next();
    }
  }
});

// 定义一个resetRouter 方法，在退出登录后或token过期后 需要重新登录时，调用即可
export function resetRouter () {
  const newRouter = new Router({
    mode: 'history',
    routes: constantRouterMap
  });
  router.matcher = newRouter.matcher
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js